import React from 'react';
import { Container, Typography, Button, Box, Paper } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { useAuth } from './AuthContext';


const Unauthorized: React.FC = () => {
  const navigate = useNavigate();
  const { role, user } = useAuth();

  return (
    <Container maxWidth="md">
      <Paper elevation={3} sx={{ mt: 8, p: 4, textAlign: 'center' }}>
        <Typography variant="h4" color="error" gutterBottom>
          אין הרשאה לתפקיד זה
        </Typography>

        <Typography variant="body1" paragraph sx={{ mt: 2 }}>
          אין לך הרשאות מספיקות לגישה לעמוד זה.
        </Typography>

        <Box sx={{ mt: 2, p: 2, bgcolor: 'background.paper', borderRadius: 1 }}>
          <Typography variant="body2">
            שם משתמש: {user?.displayName || 'לא ידוע'}
          </Typography>
          <Typography variant="body2">
            אימייל: {user?.email || 'לא ידוע'}
          </Typography>
          <Typography variant="body2">
            תפקיד נוכחי: {role || 'לא מוגדר'}
          </Typography>
        </Box>

        <Typography variant="body1" paragraph sx={{ mt: 2 }}>
          אם אתה סבור שזוהי טעות, אנא פנה למנהל המערכת.
        </Typography>

        <Box sx={{ mt: 3, display: 'flex', justifyContent: 'center', gap: 2 }}>
          <Button 
            variant="contained" 
            color="primary" 
            onClick={() => navigate('/')}
          >
            חזרה לדף הבית
          </Button>
          <Button 
            variant="outlined" 
            onClick={() => navigate('/login')}
          >
            התחברות מחדש
          </Button>
        </Box>
      </Paper>
    </Container>
  );
};

export default Unauthorized;